import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { StickyHeaderService } from '../../../services/stickyHeaderService/stickyHeader.service';
@Injectable({
  providedIn: 'root'
})
export class ChangeButtonsVisibility implements ICommunicationEvent {
	constructor(private readonly stickyHeaderService: StickyHeaderService) {}

	get eventName(): string {
		return PlatformCommunicationEvents.ChangeButtonsVisibility;
	}

	handleEvent(event: any): void {
		const payload = event.data;
		this.stickyHeaderService.changeButtonsVisibility$.next(payload);
	}
}
